import { BaseAPI } from "./BaseAPI";

import type { APIConf } from "./BaseAPI";
import type {
  GetAvailableFontListResponse,
  ProjectStyles,
  UpdateProjectStylesParams,
  UploadFontParams,
  UploadFontResponse,
} from "./StylesAPI.types";

const { localStorage } = global.window;

class StylesAPIClass extends BaseAPI {
  constructor(conf: APIConf) {
    super(conf);
    this.service = "project";
    this.version = "v4";
  }

  get organizationFontRoute(): string {
    return `${this.routeBase}/admin/organizations/fonts`;
  }

  get projectStyleRoute(): string {
    return `${this.routeBase}/admin/storefront_projects/style`;
  }

  async getAvailableFontList(): Promise<GetAvailableFontListResponse> {
    return this.axios
      .get<GetAvailableFontListResponse>(this.organizationFontRoute)
      .then((response) => response.data);
  }

  async getProjectStyles(projectSlug: string): Promise<ProjectStyles> {
    return this.axios
      .get<ProjectStyles>(this.projectStyleRoute, {
        headers: { "xx-ok-project": projectSlug },
      })
      .then((response) => response.data);
  }

  async updateProjectStyles({
    projectSlug,
    styles,
  }: UpdateProjectStylesParams): Promise<ProjectStyles> {
    return this.axios
      .put<ProjectStyles>(this.projectStyleRoute, styles, {
        headers: { "xx-ok-project": projectSlug },
      })
      .then((response) => response.data);
  }

  async uploadFont({
    fileList,
    licenseDeclaration,
  }: UploadFontParams): Promise<UploadFontResponse> {
    const formData = new FormData();
    fileList.forEach((file) => formData.append("files[]", file));
    formData.append("license_declaration", JSON.stringify(licenseDeclaration));

    return this.axios
      .post<UploadFontResponse>(this.organizationFontRoute, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => response.data);
  }

  async deleteFont(fontUuid: string): Promise<void> {
    await this.axios.delete(`${this.organizationFontRoute}/${fontUuid}`);
  }
}

const StylesAPI = new StylesAPIClass({ token: localStorage.token });

export default StylesAPI;
